export const dataStylesSelectInputPaper = {
  '&[data-style-searchable="true"]': {
    '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        '&::selection': { background: 'intial' },
        '&::-moz-selection': { background: 'intial' },
      },
  },
  '&[data-style-searchable="false"]': {
    '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        '&::selection': { background: 'transparent' },
        '&::-moz-selection': { background: 'transparent' },
      },
  },
};
